<template>
  <div id="sov">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader  ">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			 <select @change="refreshReview" v-model="selected_website" class="form-control text-uppercase">
          	<option value="amazon">Amazon</option>
          	<option value="flipkart">Flipkart</option>
          </select>
  	 		</div>
        <div class="datebox" >
          <select @change="getProducts" v-model="selectedItemCat"  class="form-control text-uppercase">
            <option v-for="d in itemCatOptions" :value="d" :key="d.key">{{ d.label }}</option>
          </select>
        </div>
        <div class="datebox" style="text-transform: capitalize;">
  	 			<div @click="showProductModal"  style="display:flex;cursor:pointer" >
              <div style="display: flex;border: 1px solid silver;padding-bottom: 5px;background: white;padding-left: 14px;padding-right: 14px;">
                <span style="margin-top: 6px;float: left;font-size: 11px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 116px;">{{ selectedProduct }} &nbsp;</span>
                <i style="padding-top: 6px;font-size: 17px;margin-left: 11px;" class="fa fa-angle-down"></i>
              </div>
              <!-- <select @change="refreshReview" v-model="selectedProduct" class="form-control text-uppercase">  
                <option value="all">All</option>           
                <option v-for="(d,i) in productOptions" :key="i" :value="d">{{d}}</option>
              </select> -->
            </div>
  	 		</div>
        <div class="datebox">
  	 				<datepicker  placeholder="From" @input="refreshReview" v-model="reviewStartDate" />
  	 		</div>
        <div class="datebox">
  	 				<datepicker v-model="reviewEndDate" class="picker-left"   placeholder="To" @input="refreshReview" />
  	 		</div>
  	 	</div>
  	</div>
    <div class="container-fluid ">
      <div class="card " style="padding: 10px;">
         <b-row style="justify-content: center;margin-top: 10px;">  
          <div class="col-md-*">
            <p style="margin-bottom: 0;padding: 7px;">Ratings:</p>
          </div>
          <div class="col-md-3   ">
            <select v-model="reviewsRatingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pl-0">
           <input v-model="reviewsRatingInput"  style="border: 1px solid silver !important;"  class="form-control filval" type="text" placeholder="Enter Value">
           <input v-if="reviewsRatingExp=='between'" v-model="reviewsRatingInput2"  style="border: 1px solid silver !important;"  class="form-control filval" type="text" placeholder="Enter Value">
          </div>
          <div  class="col-md-2 pl-0">
            <button @click="refreshReview" class="btn filval btn-primary"> Apply </button>
          </div>
      </b-row>  
        <table id="myTable" >
          <thead style="display:none"><tr><th>&nbsp;</th></tr></thead>
          <tbody style="font-family:inherit">
            <tr v-for="d in reviewsData.data" >
              <td>
                <div  class="each-review">
                  <div style="text-align:left;width:400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" >
                    <a :href="d.product_link">{{ d.product_name  }}</a> 
                  </div>
                  <div class="usericon">
                    <i class="fa fa-user" style="font-size: 15px; color: silver;"></i>
                  </div>
                  <div class="username">
                    {{ d.person_name }}
                  </div>
                <div class="usertimestamp">
                  {{ d.review_date }}
                </div>
                <div class="helpful">
                  Helpful: {{ d.found_helpful }}
                    <a :href="d.review_link" target="_blank">
                      Link
                    </a>
                </div>
                <div class="helpful" style="margin-right:5px">
                  Rating: {{d.rating}}
                 
                </div>
                <div class="usertext" style="text-align: justify;">
                  
                  {{ d.review }}
                </div>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
        
      </div>
    </div>  
    
 
    <b-modal size="lg" title="Select  " v-model="isProductModal" >
     <b-row>
        <div class="col-md-12" >
          <div style="position:relative">
            <input style="border-radius: 0;padding: 6px;font-size: 11px;height: 30px;padding-left: 30px;" class="form-control" v-model="schProduct" type="text" placeholder="Search"/>
            <i style="position:absolute;left:0;top:0;padding: 8px;" class="fa fa-search"></i>
          </div>  
        </div>
      </b-row> 

      
      <div class="space-between-header" style="padding-top:20px">
        <h6 class="m-0" >Products:</h6>
      </div>       
      <div style="padding-top:0px;cursor:pointer;height: 300px;overflow-y: scroll;text-transform: capitalize;">
        <div :class="{'selectedProduct':selectedProduct==d.product_name}" v-if="checkSearchFilter(d.product_name) " class="eachProduct" @click="selectProductNow(d.product_name)" style="padding: 4px;border-bottom: 1px solid #e6e6e6;" :key="d.product_name" v-for="d in productOptions" > {{ d.product_name }}
        </div>
         
      </div>
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'


export default {
  name: 'sov',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:'amazon',
      websitesUrls: {
        "https://www.amazon.com": "amazon_US",
        "https://www.harveynorman.com.au": "harvey",
        "https://www.bestbuy.com": "BESTBUY",
        "https://www.currys.co.uk": "currys_uk",
        "https://www.costco.com": "costco",
        "https://www.walmart.com": "walmart",
        "https://store.hp.com/us": "hp",
        "https://store.hp.com/UKStore":"hp_uk",
        "https://global.jd.com": "jd",
        "https://store.asus.com/us": "ASUS",
        "https://www.dell.com/en-us": "dell",
        "https://store.acer.com/en-us": "Acer",
        "https://www.lenovo.com/us":"lenovo",
        "https://www.lenovo.com/gb":"lenovo_uk",
        "https://www.lenovo.com/de":"lenovo_germany",
        "https://www.mediamarkt.de": "MediaMarkt"
      }, 
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      activeSentimentChart: false,
      selectedProduct: '',
      productOptions: [],
      reviewStartDate: moment().subtract(1,'week').format('YYYY-MM-DD'),
      reviewEndDate: moment().format('YYYY-MM-DD'),
      loader: true,
      modalTitle: '',
      modalSentimentType: '',
      keywordChartData: {},
      showModal: false,
      modalLoader: false,
      chartDataKey: 'original_frequency',
      chartDataMapper :{
        'original_score':'Score',
        'original_frequency':'Frequency',
        'reviews_count':'Reviews Count'
      },
      interval: 'month',
      activeModalChart: false,
      modalData: {},
      isProductModal : false,
      schProduct: '',
      deviceMapper:{
        'laptop': 'PC',
        'desktop': 'Desktop'
      },
      device: 'mixer_grinder',
      ratingInput1: '',
      ratingExp: 'eq',
      ratingInput2: '',
      pickProduct: false,
      filterChanged: false,
      cpuFilter: '',
      brandFilter: '',
      filterKeys: {
        brand: [],
        processor_type: []
      },
      reviewsRatingExp: 'eq',
      reviewsRatingInput: '',
      reviewsRatingInput2: '',
      reviewsData: {},
      customData: JSON.parse(localStorage.getItem('reviewCustomData')),
      itemCatTrack: [],
      itemCatOptions: [],
      selectedItemCat: '',
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],

    }
  },
 
  mounted()
  {
    if(localStorage.reviewStartDate)
    {
      this.reviewStartDate = localStorage.reviewStartDate
      this.reviewEndDate = localStorage.reviewEndDate
    }
    else
    {
      this.reviewStartDate = moment().subtract(2,'month').format('YYYY-MM-DD')
      this.reviewEndDate = this.date.startDate
    }
    this.products = this.customData.products 
    this.nonPrimaryProductsOptions = this.customData.nonPrimaryProductOptions
    this.primaryProductsOptions = this.customData.primaryProductOptions
    this.selectedProducts = this.customData.selectedProducts 
    this.getItemCategoryData()
    this.getProducts()
  },
  methods: {
    getItemCategoryData(){
      let self = this
      let allProducts = self.primaryProductsOptions.concat(self.nonPrimaryProductsOptions)
      for (let [i, k] of allProducts.entries())
      {
        if(!this.itemCatTrack.includes(k.item_category))
        {
          this.itemCatTrack.push(k.item_category)
          this.itemCatOptions.push({key: k.item_category,label:k.item_category.replace('_',' ').toUpperCase()})
        }
      }
      if(localStorage.vguard_selectedItemCat)
        this.selectedItemCat = JSON.parse(localStorage.vguard_selectedItemCat)
      else  
        this.selectedItemCat  = self.itemCatOptions[0]
      console.log(this.itemCatOptions)
    },
    checkSearchFilter(d){
      let self = this
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase())!=-1)
      {
        return true
      }
      else
      {
        return false
      }
    },
    goToSentiments(){
      let self = this
      window.location = "#/sentiments"

    },
    selectProductNow(d){
      let self = this
      self.selectedProduct = d
      self.pickProduct = true
      localStorage.selected_product = self.selectedProduct
      self.refreshReview()
      self.isProductModal = false
    },
    showProductModal(){
      let self = this
      self.isProductModal = true
    },
    formatDate(key,d){
      let self = this
      let obj = {
        'day': moment(d).format('MMM DD, YY'),
        'month': moment(d).format('MMM YY'),
        'week': ''
      }
      if (self[key]=='week')
      {
        let end_date = moment(d).add(6,'days')
        let today = moment(self.reviewEndDate)
        if(end_date >= today)
          end_date = today
        obj['week'] = moment(d).format('MMM DD, YY') + " - " +  moment(end_date).format('MMM DD, YY')
      }
      return obj[this[key]]
    },
    backToSov()
    { 
      window.location = '#/sov'
    },
    changeSentimentType(d){
      this.$nextTick(function(){
        this.modalSentimentType = d
        this.getKeywordWiseData()
      })
    },
    getKeywordWiseData(){
      let self = this
      self.modalLoader = true
      self.loader = true
      if(Object.keys(self.modalData).length)
      {
        $('#myTable').DataTable().destroy();
      }
      self.modalData = {}
      let url = "/api/reviews/keywordwise"
      url += "?keyword=" + self.modalTitle 
      url += "&product_name=" + self.selectedProduct 
   
      url += "&channel=" + self.websitesUrls[self.selected_website]  
      if (self.modalSentimentType)
        url += "&sentiment_type=" + self.modalSentimentType  
      url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
      console.log('here')
      self.$http.get(url).then(response => {
        self.modalData = response.body
        self.modalLoader = false
        self.loader = false
        if (!self.showModal) self.showModal = true
      }, err => {
        self.modalLoader = false
        self.loader = false
        console.log(err) 
      });
    },

    processChartData(){
      let category = []
      let series = []
      let comm_series = []
      let datakeys = [{key:'positive',label:'Positive',color:'green'},{key:'negative',label:'Negative',color:'red'}]
      let self = this
      let new_key = ""
      let org_label = ""
      let com_label = ""
      if(this.chartDataKey=="original_frequency")
      {
        new_key = "frequency"
        org_label = "Frequency"
        com_label = "Cummulative Frequency"
      }
      else if(this.chartDataKey=="original_score")
      {
        new_key = "score"
        org_label = "Score"
        com_label = "Cummulative Score"
      }
      else
      {
        new_key = "cummulative_review_count"
        org_label = "Review Count"
        com_label = "Cummulative Review Count"
      }
      for (let [i,k] of datakeys.entries())
      {
        if(this.keywordChartData.data[k.key]) 
        {
          let obj = {}
          obj.name =  k.label
          obj.data = []  
          obj.color = k.color
          let comm_obj = {}
          let format_date = ""
          comm_obj.name =  k.label
          comm_obj.data = []  
          comm_obj.color = k.color
          for(let [idx, dataset] of this.keywordChartData.data[k.key].entries())
          {
            
            category.push(self.formatDate('interval',dataset.date))
            obj.data.push(dataset[this.chartDataKey])
            comm_obj.data.push(dataset[new_key])  
          } 
          series.push(obj)
          comm_series.push(comm_obj)  
        }     
      }  
      this.plotChart({ series: series, category: category},'modalChart',org_label)
      this.plotChart({ series: comm_series, category: category},'cmodalChart',com_label)
    },
    plotChart(d,chartObj,chart_label){
      var self = this
      console.log(d) 
      if (d.category.length)
        self.activeModalChart = true
      else
        self.activeModalChart = false 
      this[chartObj] = 
      {
        credits: {
          enabled: false
        },
        chart: {
          height: 210
        },
        title: {
          text: ''
        },
        subtitle: {
            text: ''
        },

        yAxis: {
            title: {
                text: chart_label
            }
        },
        xAxis:{
          categories: d.category,
          crosshair: true,
          crosshair:{
            color: 'rgba(166, 215, 238)',
            width:2,
          } 
        },
        tooltip: {
          formatter: function() {
            var mytooltip = this.points[0].key + '<br/>';
            for(var i = 0;i<this.points.length;i++)
            {
              mytooltip += '<span style="color:' + this.points[i].series.color + '">\u25CF</span> '
              mytooltip += this.points[i].series.name
              mytooltip += ' : <b> ' + self.format(this.points[i].y) + '</b> <br/>';
            }
            return mytooltip;
          },
          shared: true
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9 
            }
          }
        },
        series: d.series
      }
    },
    refreshModal(){
      let self = this
      self.reviewStartDate = moment(self.reviewStartDate).format('YYYY-MM-DD')
      self.reviewEndDate = moment(self.reviewEndDate).format('YYYY-MM-DD')
      this.getKeywordChartData() 
      this.getKeywordWiseData()
    },
    openModal(keyword,type){
      this.modalTitle = keyword
      this.modalSentimentType = type
      this.refreshModal('datecomponent')
    },
    getKeywordChartData(){
      let self = this
      self.modalLoader = true
      self.loader = true
      self.$nextTick(function(){
        self.keywordChartData = {}
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval
        url += "&keyword=" + self.modalTitle 
        url += "&product_name=" + self.selectedProduct 
        url += "&channel=" + self.websitesUrls[self.selected_website]  
        if (self.modalSentimentType)
          url += "&sentiment_type=" + self.modalSentimentType  
       
        url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate
        self.$http.get(url).then(response => {
          self.keywordChartData = response.body
          self.modalLoader = false
          self.loader = false
          self.processChartData()
        }, err => {
          self.modalLoader = false
          self.loader = false
        });
      })
    },
    drawGaugeChart(word,positive,negative){
      let self = this
      let series = []
      let value1 = Number(positive)
      let value2 = Number(negative)
      if (value1 && value2)
      {
        let obj = {}
        obj.name = "Positive"
        obj.color = "#7fc557"
        obj.y = value1
        series.push(obj)
        let obj2 = {}
        obj2.name = "Negative"
        obj2.color = "#fb7b63"
        obj2.y = value2
        series.push(obj2)   
      }
      else
      {
        if(!value1)
        {
          let obj = {}
          obj.name = "Negative"
          obj.color = "#fb7b63"
          obj.y = value2
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "whitesmoke"
          obj2.y = 100-value2
          obj2.dataLabels = { enabled: false }
          series.push(obj2) 
        }
        if(!value2)
        {
          let obj = {}
          obj.name = "Positive"
          obj.color = "#7fc557"
          obj.y = value1
          series.push(obj)
          let obj2 = {}
          obj2.name = "other"
          obj2.color = "whitesmoke"
          obj2.y = 100-value1
          obj2.dataLabels = { enabled: false }
          series.push(obj2)
        }
      }  
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin:[0,0,0,0],
          padding:[0,0,0,0],
          height:110,
          width:180
        },
        title: {  
            text: '',
        },
        credits: {
          enabled: false
        },
        accessibility: {
          point: {
              valueSuffix: '%'
          }
        },
        tooltip: {
          formatter(){
            if(this.point.name == 'other')
            {
              return false
            }
            var mytooltip = ''
            // console.log(this.point)
            mytooltip += '<span style="color:' + this.point.color + '!important">\u25CF</span> '
            mytooltip += this.point.name
            mytooltip += ' : <b> ' + self.format(this.point.y) + '%</b> <br/>'
            return mytooltip;             
          },
        },
        plotOptions: {
            series: {
                borderWidth: 0,
            },
            pie: {
                dataLabels: {
                  enabled:true,
                  distance: -15,
                  format: '{point.y:.1f}',
                  style: {
                    fontSize:11, 
                  },
                  color:'black'  
                },
                showInLegend: true,
                startAngle: -90,
                endAngle: 90,
                size: '100%',
                center: ['50%', '57%'],
            }
        },
        legend:{
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1,
          }
        },  
        series: [{  
          type: 'pie',
          innerSize: '59%',
          data: series
        }]
      }
    },
    getSentiment(){
      let self = this      
      self.loader = true
      let payload = {
        "product_name": self.selectedProduct,
        "channel": self.websitesUrls[self.selected_website],
        "start_date":moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date":moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "item_category": self.device,
      }
      const url = "/api/websites/review_sentiment"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.sentimentData = response.body.table
        for (let [y, td] of response.body.table.entries())
        {
          if (td.positive_score == null)
          {
            td.positive_score  = 0
          }
          if (td.negative_score == null)
          {
            td.negative_score  = 0
          }
          self.drawGaugeChart(td.word,td.positive_score,td.negative_score)
        }
       
      }, err => {
        self.loader = false
        console.log('err')
      });
    }, 
    refreshReview(){
      let self = this
      localStorage.reviewStartDate = this.reviewStartDate
      localStorage.reviewEndDate = this.reviewEndDate
      if(self.selectedProduct)
        {
          localStorage.selected_product = self.selectedProduct
          self.getReviews()
        }
    },
    getReviews(){
      let self = this
      self.loader = true
      let payload = {
        "start_date":moment(self.reviewStartDate).format('YYYY-MM-DD'),
        "end_date":moment(self.reviewEndDate).format('YYYY-MM-DD'),
        "interval": self.revInterval,
        "client": "vguard",
        "item_category": self.selectedItemCat.key,
      }
      if(self.reviewsRatingInput)
      {
        payload['rating'] = {}
        if (self.reviewsRatingExp !='between')
        {
          payload['rating'][self.reviewsRatingExp] = self.reviewsRatingInput
        }
        else
        {
          payload['rating']['lte'] = self.reviewsRatingInput2
          payload['rating']['gte'] = self.reviewsRatingInput
        }
      }
     

        

      if (self.selected_website != 'all')
      {
        payload["channel"] = self.selected_website
      }
      if ( self.selectedProduct != 'all')
      {
        payload["product_name"] = [self.selectedProduct]
      }
      if(self.ratingInput1)
      {
        if(self.pickProduct)
        {
          if(self.selectedProduct!='all')
            payload["product_name"] = [self.selectedProduct]
          else
            payload["product_name"] = self.productOptions
        }
        else 
        {
          payload["product_name"] = self.productOptions
        }  
      }
      if(Object.keys(self.reviewsData).length)
      {
        $('#myTable').DataTable().destroy();
      }
      self.reviewsData = {}
     
      const url = "/api/reviews/list"
      self.$http.post(url, payload ).then(response => {
        self.loader = false
        self.reviewsData = response.body
        self.$nextTick(function(){
          $('#myTable').dataTable({
            "searching": false,
            "info": false,
            "bLengthChange": false,
            "pageLength": 20,
          })
        })
      }, err => {
        self.loader = false
        console.log('err')
      });

    },
    getProducts(){
      let self = this
      localStorage.vguard_selectedItemCat = JSON.stringify(this.selectedItemCat)
      this.productOptions = []
      let allProducts = this.customData.primaryProductOptions.concat(this.customData.nonPrimaryProductOptions)
      for (let [i, k] of allProducts.entries())
      {
        if(k.item_category == self.selectedItemCat.key)
        {
          this.productOptions.push(k)
        }
      }
      this.selectedProduct = this.productOptions[0].product_name
      self.refreshReview()
    },
 
    format(v)
    {
      return this.$options.filters.format(v)
    },
  }
}

</script>

<style scoped>
.selectedProduct
{
  background: #8e8d8d!important;
  color: White!important;
}
.cardper
{
      float: right;
    position: absolute;
    right: 11px;
    bottom: 0;
    font-size: 29px;
    color: white;
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
 
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color:#4e4e4e;
    margin-bottom: 0;
    line-height: 31px;
}

.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
 .customselect
  {
    height: 34px;
    border-radius: 0;
    background: white;
    border: 1px solid silver;
    padding-left: 11px;
    padding-right: 11px;
    margin-right: 5px;
  }
  .eachProduct:hover
{
    background: #d4d4d4;
}
</style>
